import styled, { keyframes } from 'styled-components';

export const pulse = keyframes`
    0%, 100% { opacity: 1; }
    50% { opacity: 0.6; }
`;

export const fadeIn = keyframes`
    from { opacity: 0; transform: translateY(8px); }
    to   { opacity: 1; transform: translateY(0); }
`;

export const ripple = keyframes`
    0%   { transform: scale(0.8); opacity: 0.8; }
    100% { transform: scale(2.2); opacity: 0; }
`;

export const VideoWrapper = styled.div`
    width: 100%;
    height: 100%;
    background-color: #000;
    position: relative;
    overflow: hidden;
    cursor: pointer;

    &:hover > div[data-controls] {
        opacity: 1;
        transform: translateY(0);
    }
`;

export const VideoElement = styled.video`
    width: 100%;
    height: 100%;
    object-fit: contain;
    background-color: #000;
    display: block;
`;

export const BlockOverlay = styled.div`
    position: absolute;
    inset: 0;
    z-index: 5;
    user-select: none;
`;

export const ControlBar = styled.div.attrs({ 'data-controls': '' })`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    gap: 12px;
    background: linear-gradient(transparent, rgba(0,0,0,0.75));
    opacity: 0;
    transform: translateY(6px);
    transition: opacity 0.3s ease, transform 0.3s ease;
    animation: ${fadeIn} 0.4s ease both;
`;

export const IconButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    opacity: 0.9;
    transition: opacity 0.2s, transform 0.15s;

    &:hover {
        opacity: 1;
        transform: scale(1.15);
    }
    &:active {
        transform: scale(0.95);
    }
`;

export const TimeLabel = styled.span`
    font-size: 0.75rem;
    font-weight: 600;
    color: rgba(255,255,255,0.85);
    letter-spacing: 0.04em;
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
    min-width: 90px;
`;

export const Spacer = styled.div`flex: 1;`;

export const ProgressTrack = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: rgba(255,255,255,0.15);
    z-index: 11;
`;

export const ProgressFill = styled.div`
    height: 100%;
    width: ${({ $percent }) => $percent}%;
    background: ${({ $reached }) =>
        $reached
            ? 'linear-gradient(90deg, #22c55e, #4ade80)'
            : 'linear-gradient(90deg, #3b82f6, #60a5fa)'};
    border-radius: 0 99px 99px 0;
    transition: width 0.4s ease, background 0.4s ease;
`;

export const ProgressOverlay = styled.div`
    position: absolute;
    bottom: 56px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    pointer-events: none;
    z-index: 10;
    padding: 8px 14px;
    border-radius: 12px;
    background: rgba(0,0,0,0.55);
    backdrop-filter: blur(6px);
    border: 1px solid rgba(255,255,255,0.1);
    min-width: 180px;
`;

export const ProgressBarTrack = styled.div`
    width: 100%;
    height: 5px;
    background: rgba(255,255,255,0.2);
    border-radius: 99px;
    overflow: hidden;
`;

export const ProgressBarFill = styled.div`
    height: 100%;
    width: ${({ $percent }) => $percent}%;
    background: ${({ $reached }) =>
        $reached
            ? 'linear-gradient(90deg, #22c55e, #4ade80)'
            : 'linear-gradient(90deg, #3b82f6, #60a5fa)'};
    border-radius: 99px;
    transition: width 0.4s ease, background 0.4s ease;
`;

export const ProgressLabel = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 0.72rem;
    font-weight: 600;
    color: ${({ $reached }) => ($reached ? '#4ade80' : '#cbd5e1')};
    letter-spacing: 0.03em;
    transition: color 0.4s ease;
`;

export const Dot = styled.span`
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${({ $reached }) => ($reached ? '#4ade80' : '#60a5fa')};
    animation: ${pulse} 1.5s ease-in-out infinite;
    display: ${({ $reached }) => ($reached ? 'none' : 'block')};
`;

export const RippleCircle = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    width: 60px;
    height: 60px;
    margin: -30px 0 0 -30px;
    border-radius: 50%;
    background: rgba(255,255,255,0.25);
    pointer-events: none;
    z-index: 6;
    animation: ${ripple} 0.5s ease forwards;
`;

export const VolumeWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
`;

export const VolumeSlider = styled.input`
    -webkit-appearance: none;
    appearance: none;
    width: 64px;
    height: 3px;
    background: linear-gradient(
        to right,
        rgba(255,255,255,0.9) 0%,
        rgba(255,255,255,0.9) ${({ $vol }) => $vol}%,
        rgba(255,255,255,0.25) ${({ $vol }) => $vol}%,
        rgba(255,255,255,0.25) 100%
    );
    border-radius: 99px;
    cursor: pointer;
    outline: none;

    &::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #fff;
        cursor: pointer;
    }
`;
